import { render } from "./ParcProfileParcCardDataTables.vue?vue&type=template&id=6ca7e2fe"
import script from "./ParcProfileParcCardDataTables.vue?vue&type=script&lang=js"
export * from "./ParcProfileParcCardDataTables.vue?vue&type=script&lang=js"

import "./ParcProfileParcCardDataTables.vue?vue&type=style&index=0&id=6ca7e2fe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__